import React from 'react'
import mark from 'images/souSouMark.svg'
import { describeItem, formatCents } from '../../souSouFormat'
import './index.styl'

// Sou-Sou "Draw ticket" card (design: My Wallet.html, .tk-ss). The whole card links to the circle on the Sou-Sou site.
// `souSouUrl` is the validated REACT_APP_SOU_SOU_URL (ends with a slash); the card renders nothing without it.
const SouSouCard = ({ item, souSouUrl }) => {
  if (!souSouUrl) return null
  const amount = formatCents(item.drawAmountCents)
  return (
    <a className='wrapperSouSouCard' href={`${souSouUrl}circles/${encodeURIComponent(item.circleId)}`} data-screen-label='Sou-Sou draw ticket'>
      <div className='ticketBody' />
      <div className='ticketTop'>
        <div className='brand'><img src={mark} alt='' /><b>Sou-Sou</b></div>
        <div className='kick'>Draw ticket</div>
        <div className='circleName' title={item.name}>{item.name}</div>
      </div>
      <div className='ticketDots' />
      <div className='ticketBottom'>
        <div className='label'>Your guaranteed draw</div>
        {amount && <div className='amount'>{amount}</div>}
        <div className='sub'>{describeItem(item)}</div>
      </div>
    </a>
  )
}

export default SouSouCard
